export function isNullOrUndefined(param) {
  return typeof param === 'undefined' || param === null;
}

export function hasNoLength(param) {
  return typeof param.length === 'undefined' || param.length === 0;
}

export function fakeFetch(ms, func, shouldFail = false) {
  return new Promise(
    (resolve, reject) => {
      setTimeout(() => {
        if (shouldFail === true) {
          reject(new Error('fakeFetch failure'));
        }

        resolve(func());
      }, ms);
    });
}

export const getIsIncomplete = (isRejected, isAccepted) =>
  isAccepted === false && isRejected === false;

export function displayNoneIfEmptyOrNullString(str) {
  if (typeof str === 'undefined' || str === null || str.trim() === '') {
    return 'NONE';
  }
  return str;
}
